import createEntity from './lib/resource-entity';
import createLocalEntity from './lib/resource-local-entity';
import createCollection from './lib/resource-collection';

export { createEntity, createLocalEntity, createCollection };
